import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instanceps1mclk6cv3l as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.d4h_1 = 8192;
        this.e4h_1 = 1024;
      }
      f4h() {
        return Segment().g4h();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.e4f_1 = 0;
  _this__u8e3s4.f4f_1 = 0;
  _this__u8e3s4.g4f_1 = null;
  _this__u8e3s4.h4f_1 = false;
  _this__u8e3s4.i4f_1 = null;
  _this__u8e3s4.j4f_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      i4g() {
        var tmp0_safe_receiver = this.g4f_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h4h();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static g4h() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.d4f_1 = new Int8Array(8192);
        $this.h4f_1 = true;
        $this.g4f_1 = null;
        return $this;
      }
      static i4h(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.d4f_1 = data;
        $this.e4f_1 = pos;
        $this.f4f_1 = limit;
        $this.g4f_1 = shareToken;
        $this.h4f_1 = owner;
        return $this;
      }
      q4f() {
        var tmp0_elvis_lhs = this.g4f_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.j4h();
          this.g4f_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.e4f_1;
        var tmp_1 = this.f4f_1;
        // Inline function 'kotlin.also' call
        t.k4h();
        return Segment().i4h(this.d4f_1, tmp_0, tmp_1, t, false);
      }
      l4g() {
        var result = this.i4f_1;
        if (!(this.j4f_1 == null)) {
          ensureNotNull(this.j4f_1).i4f_1 = this.i4f_1;
        }
        if (!(this.i4f_1 == null)) {
          ensureNotNull(this.i4f_1).j4f_1 = this.j4f_1;
        }
        this.i4f_1 = null;
        this.j4f_1 = null;
        return result;
      }
      r4f(segment) {
        segment.j4f_1 = this;
        segment.i4f_1 = this.i4f_1;
        if (!(this.i4f_1 == null)) {
          ensureNotNull(this.i4f_1).j4f_1 = segment;
        }
        this.i4f_1 = segment;
        return segment;
      }
      j4g(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.f4f_1 - this.e4f_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.q4f();
        } else {
          prefix = SegmentPool_instance.r3w();
          var tmp0 = this.d4f_1;
          var tmp2 = prefix.d4f_1;
          var tmp5 = this.e4f_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.e4f_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.f4f_1 = prefix.e4f_1 + byteCount | 0;
        this.e4f_1 = this.e4f_1 + byteCount | 0;
        if (!(this.j4f_1 == null)) {
          ensureNotNull(this.j4f_1).r4f(prefix);
        } else {
          prefix.i4f_1 = this;
          this.j4f_1 = prefix;
        }
        return prefix;
      }
      s4f() {
        // Inline function 'kotlin.check' call
        if (!!(this.j4f_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.j4f_1).h4f_1)
          return this;
        var byteCount = this.f4f_1 - this.e4f_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.j4f_1).f4f_1 | 0) + (ensureNotNull(this.j4f_1).i4g() ? 0 : ensureNotNull(this.j4f_1).e4f_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.j4f_1;
        this.k4g(ensureNotNull(predecessor), byteCount);
        var successor = this.l4g();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.s4g(this);
        return predecessor;
      }
      o4g(byte) {
        var _unary__edvuaz = this.f4f_1;
        this.f4f_1 = _unary__edvuaz + 1 | 0;
        this.d4f_1[_unary__edvuaz] = byte;
      }
      q4g(short) {
        var data = this.d4f_1;
        var limit = this.f4f_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.f4f_1 = limit;
      }
      l4f() {
        var _unary__edvuaz = this.e4f_1;
        this.e4f_1 = _unary__edvuaz + 1 | 0;
        return this.d4f_1[_unary__edvuaz];
      }
      n4f() {
        var data = this.d4f_1;
        var pos = this.e4f_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.e4f_1 = pos;
        return s;
      }
      k4g(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.h4f_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.f4f_1 + byteCount | 0) > 8192) {
          if (sink.i4g())
            throw IllegalArgumentException().od();
          if (((sink.f4f_1 + byteCount | 0) - sink.e4f_1 | 0) > 8192)
            throw IllegalArgumentException().od();
          var tmp0 = sink.d4f_1;
          var tmp2 = sink.d4f_1;
          var tmp5 = sink.e4f_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.f4f_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.f4f_1 = sink.f4f_1 - sink.e4f_1 | 0;
          sink.e4f_1 = 0;
        }
        var tmp0_0 = this.d4f_1;
        var tmp2_0 = sink.d4f_1;
        var tmp4 = sink.f4f_1;
        var tmp6 = this.e4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.e4f_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.f4f_1 = sink.f4f_1 + byteCount | 0;
        this.e4f_1 = this.e4f_1 + byteCount | 0;
      }
      w4f(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.d4f_1;
        var tmp6 = this.e4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.e4f_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.e4f_1 = this.e4f_1 + len | 0;
      }
      g4g(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.d4f_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.f4f_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.f4f_1 = this.f4f_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      q2() {
        return this.f4f_1 - this.e4f_1 | 0;
      }
      f4g() {
        return this.d4f_1.length - this.f4f_1 | 0;
      }
      l4h(readOnly) {
        return this.d4f_1;
      }
      u4f(index) {
        return this.d4f_1[this.e4f_1 + index | 0];
      }
      m4h(index, value) {
        this.d4f_1[this.f4f_1 + index | 0] = value;
      }
      n4h(index, b0, b1) {
        var d = this.d4f_1;
        var l = this.f4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      o4h(index, b0, b1, b2) {
        var d = this.d4f_1;
        var l = this.f4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      p4h(index, b0, b1, b2, b3) {
        var d = this.d4f_1;
        var l = this.f4f_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.q2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      h4h() {
        return true;
      }
      k4h() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.q2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.q2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var p = _this__u8e3s4.e4f_1;
  var data = _this__u8e3s4.l4h(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance1rs3z6uqvhgfu,
  Companion_instance as Companion_instancecsbm5ewxyfnq,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
